// extracted by mini-css-extract-plugin
module.exports = {"jumbotronMain":"JumbotronMain_jumbotronMain__31oRP"};